import React, { Component } from "react";
import { Form, Row, Col, Button } from "antd";
import classNames from "classnames";
import styles from "./index.less";

class Index extends Component {
  onSubmit = e => {
    e.preventDefault();
    const { form, handleQuery } = this.props;
    const { validateFields } = form;
    validateFields((err, values) => {
      if (handleQuery) {
        handleQuery(values);
      }
    });
  };

  onReset = () => {
    const { form, handleReset } = this.props;
    const { resetFields } = form;
    resetFields();

    if (handleReset) {
      handleReset();
    }
  };

  toggle = () => {
    const { expand } = this.state;
    this.setState({ expand: !expand });
  };

  render() {

    const {
      children,
      btnSmSpan,
      btnLgSpan,
      className,
      buttonColProps,
      btnColProps,
      formLayoutProps,
    } = this.props;

    return (
      <Form
        className={classNames({ [styles.root]: true, [className]: true })}
        onSubmit={this.onSubmit}
        {...formLayoutProps}
      >
        <Row gutter={24}>
          {children}
          <Col
            sm={{ span: btnSmSpan || 24 }}
            lg={{ span: btnLgSpan || 8 }}
            style={{ textAlign: 'right', lineHeight: '32px' }}
            {...btnColProps}
            {...buttonColProps}
          >
            <Button type="primary" htmlType="submit">
              查询
            </Button>
            <Button style={{ marginLeft: 8 }} onClick={this.onReset}>
              重置
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default Index;
